module.exports = __webpack_public_path__ + "img/6right-n-1cccf39b.png";